import React, { useState } from "react";
import { useParams } from "react-router-dom";
import ColorInit from "../helper/ColorInit";
import Preloader from "../helper/Preloader";
import VendorProducts from "../components/VendorProducts";

const VendorProductsPage = () => {
  const { id } = useParams();

  const [selectedCurrency, setSelectedCurrency] = useState(
    localStorage.getItem("selectedCurrency")
  );

  const handleCurrencyChange = (currency) => {
    setSelectedCurrency(currency);
    localStorage.setItem("selectedCurrency", currency);
  };

  return (
    <>
      {/* ColorInit */}
      <ColorInit color={true} />

      {/* Preloader */}
      <Preloader />

      {/* VendorProducts already has HeaderOne + FooterOne inside */}
      <VendorProducts
        selectedCurrency={selectedCurrency}
        onCurrencyChange={handleCurrencyChange}
      />
    </>
  );
};

export default VendorProductsPage;